import { useEffect } from 'react';

const SITE_NAME = 'Catholic Voices & Prayers';
const SITE_URL = 'https://catholicvoicesandprayers.com';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;
const DEFAULT_KEYWORDS = 'Traditional Latin Mass, Catholic prayers, daily saints, Eastern Catholic, FSSP, ICKSP, Ordinariate, mass finder, Catholic rosary, novena prayers, saint of the day, Catholic devotions, traditional Catholic, reverent mass, Catholic teachings, feast days, litany, traditional Latin mass near me';

function setMetaTag(attr, attrValue, content) {
  let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLinkTag(rel, href, extra) {
  const selector = extra 
    ? `link[rel="${rel}"][${Object.keys(extra)[0]}="${Object.values(extra)[0]}"]`
    : `link[rel="${rel}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    if (extra) Object.entries(extra).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function setSchema(schema) {
  let el = document.querySelector('script[data-seo-schema]');
  if (!el) {
    el = document.createElement('script');
    el.setAttribute('type', 'application/ld+json');
    el.setAttribute('data-seo-schema', 'true');
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(schema);
}

const SEO = ({ 
  title = SITE_NAME,
  description = 'Discover traditional Catholic prayers, find a reverent Mass near you, and grow in your faith. Daily saints, the Rosary, novenas, and more — all in one sacred space.',
  keywords = DEFAULT_KEYWORDS,
  image = DEFAULT_IMAGE,
  path = '',
  type = 'website',
  schema = null,
}) => {
  const canonicalUrl = `${SITE_URL}${path}`;
  const absoluteImage = image?.startsWith('http') ? image : `${SITE_URL}${image}`;

  useEffect(() => {
    document.title = title;
    
    setMetaTag('name', 'description', description);
    setMetaTag('name', 'keywords', keywords);

    setLinkTag('canonical', canonicalUrl);
    setLinkTag('alternate', canonicalUrl, { hreflang: 'en' });

    setMetaTag('property', 'og:type', type);
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:image', absoluteImage);
    setMetaTag('property', 'og:url', canonicalUrl);
    setMetaTag('property', 'og:site_name', SITE_NAME);
    setMetaTag('property', 'og:locale', 'en_US');

    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', title);
    setMetaTag('name', 'twitter:description', description);
    setMetaTag('name', 'twitter:image', absoluteImage);

    if (schema) {
      setSchema(schema);
    }

    return () => {
      const schemaEl = document.querySelector('script[data-seo-schema]');
      if (schemaEl) schemaEl.remove();
    };
  }, [title, description, keywords, canonicalUrl, absoluteImage, type, schema]);

  return null;
};

export default SEO;
